module.exports = __webpack_public_path__ + "img/logo.1edafed3.png";